module.exports = __webpack_public_path__ + "static/media/add-screen.46f426ec.png";